import React from 'react';
import CommonDataTable from './commonTable';
import BookingDetails from '../OffCanvas/others/BookingDetails';
import { __jobStatus, __jobStatusDisplay } from '../../constants';
import { formatWithTZ } from '../../utils';

const Bookings = () => {
  const [canvasState, setCanvasState] = React.useState({
    open: false,
    userId: ""
  });

  const columns = [
    {
      id: "status",
      label: "Status",
      width: "1.6fr",
      isDefault: true,
      render: (item, statusClassMap) => (
        <li style={{ overflow: "hidden", display: "flex" }}>
          <li className={`list_card_status ${statusClassMap[item.jobStatus] || ""}`}>
            {__jobStatusDisplay[item.jobStatus] || "Unknown"}
          </li>
        </li>
      )
    },
    {
      id: "bookingNo",
      label: "Booking No",
      width: "1fr",
      isDefault: true,
      render: (item) => <li>{item.displayedJobId || "NA"}</li>
    },
    {
      id: "description",
      label: "Booking description",
      width: "3fr",
      isDefault: false,
      render: (item) => <li>{item.jobDescription || "NA"}</li>
    },
    {
      id: "customer",
      label: "Customer",
      width: "1.8fr",
      isDefault: true,
      render: (item) => <li>{item.jobPostedBy.firstName} {item.jobPostedBy.lastName}</li>
    },
    {
      id: "bookingFor",
      label: "Booking for",
      width: "1.3fr",
      isDefault: true,
      render: (item) => <li>{item.jobPostedFor || "NA"}</li>
    },
    {
      id: "durationType",
      label: "Duration Type",
      width: "1.3fr",
      isDefault: true,
      render: (item) => (
        <li style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${
            item.durationType === "Immediate" ? "duration_immediate" :
            item.durationType === "Long Term" ? "duration_long_term" :
            "duration_future"
          }`}>
            {item.durationType || "Future"}
          </span>
        </li>
      )
    },
    {
      id: "bookedFinalizedOn",
      label: "Booked / Finalized on",
      width: "2.5fr",
      isDefault: false,
      render: (item) => (
        <li>
          {formatWithTZ(item.createdAt, "Do MMM, YYYY")} /{" "}
          {item.jobStatus === __jobStatus.finalized
            ? formatWithTZ(item.completedOn, "Do MMM, YYYY")
            : "--"}
        </li>
      )
    },
    {
      id: "stripeDisabled",
      label: "Stripe Disabled",
      width: "1.5fr",
      isDefault: false,
      render: (item) => (
        <li style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${item.stripeDisabled ? "status_inactive" : "status_active"}`}>
            {item.stripeDisabled ? "Disabled" : "Enabled"}
          </span>
        </li>
      )
    },
    {
      id: "provider",
      label: "Provider",
      width: "1.5fr",
      isDefault: true,
      render: (item) => <li>{item.applicationInfo?.firstName + " " + item.applicationInfo?.lastName}</li>
    }
  ];

  const handleRowClick = (item, setCanvasState) => {
    setCanvasState({
      open: true,
      applicationId: item.applicationInfo._id,
      haveInvoice: [__jobStatus.finalized].includes(item.jobStatus)
    });
  };

  return (
    <CommonDataTable
      type="Booking"
      profileNavTitle="Bookings"
      columns={columns}
      viewColumnWidth="0.8fr"
      onRowClick={handleRowClick}
      canvasComponent={BookingDetails}
      canvasState={canvasState}
      setCanvasState={setCanvasState}
      additionalParams={{}}
    />
  );
};

export default Bookings;